import { type FC } from 'react';
import cn from 'classnames';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import wavesPng from '/img/patterns/waves-v2.png';
import wavesWebp from '/img/patterns/waves-v2.webp';

interface WavesBackgroundProps {
  className?: string;
}

const WavesBackground: FC<WavesBackgroundProps> = ({ className }) => {
  return (
    <BackgroundWrapper
      className={cn(
        'w-full absolute top-0 left-0 aspect-[428/274] overflow-hidden rounded-t-2xl',
        className,
      )}
    >
      <Picture
        img={wavesPng}
        webp={wavesWebp}
        className="absolute top-0 left-0 z-[1]"
        alt="walves"
      />
      <span className={css.ellipseTop}></span>
      <span className={css.effect}></span>
    </BackgroundWrapper>
  );
};

export { WavesBackground };
